import { RESET_PASSWORD_VERIFY_PHONE_PATH } from '../../../react-router-paths';
import { AlternativeContactLinkProps } from '../alternative-contact-link';

export const phoneContactLinkProps: AlternativeContactLinkProps = {
    contactType: 'phone',
    to: RESET_PASSWORD_VERIFY_PHONE_PATH
};
